import { Pipe, PipeTransform } from "@angular/core";
import { EnvioDTO } from "@DTOS";

@Pipe({
    name: "estadoEnvioTexto"
})
export class EstadoEnvioTextoPipe implements PipeTransform {

    transform(envio: EnvioDTO): string {
        const dispatched = envio.fechaEnvio.getMilliseconds() < Date.now();
        return envio.activo ? (dispatched ? "Activa" : "Esperando") : "Inactiva";
    }

}
